const EVENT_ALIASES = {
  call_click: "phone_click",
  business_view: "service_view",
  search_submit: "tire_service_search",
  booking_begin: "booking_start",
  booking_success: "booking_complete",
  business_application_submit: "owner_application_submit",
};

const PAGE_NAMES = {
  home: "home",
  detail: "detail",
  booking: "booking",
  success: "success",
  auth: "auth",
  dashboard: "dashboard",
  business: "business landing",
  "business-apply": "business apply",
  "biz-dashboard": "business dashboard",
  admin: "admin",
};

let initialized = false;
let measurementId = "";
// Existing production bundle: index-Bs9xXh7y.js.
export const MEASUREMENT_ID = 'G-28ZRZXE025';
const ATTR_KEY = 'torqo.ga4.first-touch.v1';
const DONE_KEY = 'torqo.ga4.completed.v1';
const TELEGRAM_KEY = 'torqo.ga4.telegram-pending.v1';
const recent = new Map();
const completed = new Set();
let attribution = {};
let lastPage = '';
function read(storage,key,fallback) { try { return JSON.parse(window[storage].getItem(key)) || fallback; } catch { return fallback; } }
function write(storage,key,value) { try { window[storage].setItem(key,JSON.stringify(value)); } catch {} }
function isLocal() {
  const host=window.location.hostname.toLowerCase();
  return !/^https?:$/.test(window.location.protocol) || /^(localhost|.*\.localhost|127\..*|0\.0\.0\.0|\[::1\]|::1|10\..*|192\.168\..*|172\.(1[6-9]|2\d|3[01])\..*)$/.test(host) || host.endsWith('.local');
}
const sources = new Set(['google','bing','facebook','instagram','telegram','tiktok','youtube','newsletter','partner','direct','referral']);
const mediums = new Set(['cpc','ppc','organic','social','paid_social','email','referral','messenger','none']);
// Controlled campaign vocabulary prevents names/addresses hidden in UTM values.
const campaignWords = new Set(['torqo','tire','tires','service','search','dnipro','brand','launch','summer','winter','spring','autumn','retargeting','banner','post','story','bio','reminder','owner','booking','promo','organic','paid']);
function cleanAttribution(input) {
  const result = {};
  if(sources.has(input?.utm_source)) result.utm_source=input.utm_source;
  if(mediums.has(input?.utm_medium)) result.utm_medium=input.utm_medium;
  for(const key of ['utm_campaign','utm_content','utm_term']) {
    const value=String(input?.[key]||'').toLowerCase();
    if(value && value.length<=80 && value.split(/[-_]/).every(w=>campaignWords.has(w)||/^(20\d{2}|[1-9])$/.test(w))) result[key]=value;
  }
  result.traffic_source=sources.has(input?.traffic_source)?input.traffic_source:result.utm_source||'direct';
  return result;
}
function firstTouch() {
  const saved=read('localStorage',ATTR_KEY,null);
  if(saved && typeof saved==='object') return cleanAttribution(saved);
  const query=new URLSearchParams(window.location.search);
  const input=Object.fromEntries(['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].map(k=>[k,(query.get(k)||'').toLowerCase()]));
  let source=query.has('utm_source')?'referral':'direct';
  try { const ref=new URL(document.referrer); if(ref.origin!==window.location.origin) source=/(^|\.)google\.[a-z.]+$/.test(ref.hostname)?'google':/(^|\.)bing\.com$/.test(ref.hostname)?'bing':'referral'; } catch {}
  input.traffic_source=sources.has(input.utm_source)?input.utm_source:source;
  const result=cleanAttribution(input);
  write('localStorage',ATTR_KEY,result);
  return result;
}
// URLs can contain personal data, claim tokens, form values and arbitrary UTM.
function pageContext() { return {page_location:window.location.origin+'/',page_referrer:'',page_title:'Torqo'}; }

function loadGtag(id) {
  if (document.querySelector(`script[data-torqo-ga4="${id}"]`)) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  script.dataset.torqoGa4 = id;
  script.onerror = () => {};
  document.head.appendChild(script);
}

function gtagSafe(...args) {
  try {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === "function") {
      window.gtag(...args);
      return true;
    }
    if(window.dataLayer.length<500) window.dataLayer.push(args);
    return true;
  } catch {
    return false;
  }
}

function sanitizeParams(params={}) {
  const clean={};
  for(const key of ['business_id','service_id','booking_id']) {
    const value=String(params[key]??'');
    if(/^(?:[1-9]\d{0,8}|1\d{12}|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i.test(value))clean[key]=value;
  }
  // Business display names are user supplied and can themselves be personal names.
  if(params.service_name==='tire_service')clean.service_name='tire_service';
  if(params.city==='Dnipro')clean.city='Dnipro';
  if(['district','address','city','filters','geolocation'].includes(params.search_query))clean.search_query=params.search_query;
  for(const key of ['filters','filter_type'])if(typeof params[key]==='string')clean[key]=params[key].split(',').filter(k=>['district','service','size','vehicle','maxDistance','maxPrice','openNow','is24','mobile','puncture','today','verified','city'].includes(k)).sort().join(',')||'none';
  if(Object.hasOwn(PAGE_NAMES,params.source_page))clean.source_page=params.source_page;
  return clean;
}
export function initAnalytics() {
  try {
    measurementId = import.meta.env?.VITE_GA_MEASUREMENT_ID || MEASUREMENT_ID;
    if(!/^G-[A-Z0-9]+$/.test(measurementId)||initialized||typeof window==='undefined'||isLocal())return false;
    attribution=firstTouch();
    const saved=read('sessionStorage',DONE_KEY,[]);
    if(Array.isArray(saved))saved.slice(-500).filter(v=>typeof v==='string').forEach(v=>completed.add(v));
    window.dataLayer=window.dataLayer||[];
    window.gtag=window.gtag||function(){if(window.dataLayer.length<500)window.dataLayer.push(arguments);};
    gtagSafe('js',new Date());
    if(!gtagSafe('config',measurementId,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,...pageContext(),...(new URLSearchParams(window.location.search).get('ga_debug')==='1'?{debug_mode:true}:{})}))return false;
    loadGtag(measurementId);
    initialized=true;
    return true;
  }catch{return false;}
}
export function trackPageView(page,params={}) {
  try {
    if(!initialized||isLocal())return false;
    const name=Object.hasOwn(PAGE_NAMES,page)?PAGE_NAMES[page]:'other';
    const clean=sanitizeParams(params);
    const key=name+':'+(clean.business_id||'');
    if(lastPage===key)return false;
    const sent=gtagSafe('event','page_view',{...pageContext(),...clean,...attribution,page_title:'Torqo - '+name,torqo_page:name});
    if(sent)lastPage=key;
    return sent;
  }catch{return false;}
}
const EVENTS=new Set(['tire_service_search','service_view','route_click','phone_click','booking_start','booking_complete','owner_application_submit','telegram_reminder_enable','location_allowed','location_denied','filter_used','favorite_add','favorite_remove','booking_cancel','review_submit','business_application_begin','price_report_submit','booking_error','emergency_mode_open']);
export function trackEvent(eventName,params={}) {
  try {
    if(!initialized||isLocal())return false;
    const name=EVENT_ALIASES[eventName]||eventName;
    if(!EVENTS.has(name))return false;
    const clean=sanitizeParams(params);
    const once=name==='booking_complete'?clean.booking_id:name==='owner_application_submit'?clean.business_id:undefined;
    const onceKey=once?name+':'+once:'';
    const key=name+JSON.stringify(clean);
    const now=Date.now();
    if((onceKey&&completed.has(onceKey))||(recent.has(key)&&now-recent.get(key)<1000))return false;
    const sent=gtagSafe('event',name,{...pageContext(),...clean,...attribution});
    if(sent){
      recent.set(key,now);
      if(recent.size>200)recent.delete(recent.keys().next().value);
      if(onceKey){completed.add(onceKey);write('sessionStorage',DONE_KEY,[...completed].slice(-500));}
    }
    return sent;
  }catch{return false;}
}

export function track(type, businessId, metadata = {}) {
  return trackEvent(type, {
    business_id: businessId,
    ...metadata,
  });
}

// Keep connection intent separate from UI state; survives return from Telegram.
export function beginTelegramReminderConnection() {
  try { write('sessionStorage',TELEGRAM_KEY,Date.now()); } catch {}
}
export function confirmTelegramReminderConnection(enabled,params={}) {
  try {
    const started=Number(read('sessionStorage',TELEGRAM_KEY,0));
    if(!enabled||!started||Date.now()-started>30*60*1000)return false;
    write('sessionStorage',TELEGRAM_KEY,0);
    return trackEvent('telegram_reminder_enable',params);
  }catch{return false;}
}
